import * as THREE from 'three'
// import Scoll from 'views/Scoll'
let TWEEN = require('@tweenjs/tween.js')

let tani = {t: 0.99, OldY: 0.0}
// let scollFun

class Scene7 {
  constructor (loadmodel) {
    console.log('结束动画')
    var html = document.getElementById('white')
    // html.style.display = 'block'
    // html.style.opacity = 0
    var dis_ = loadmodel.tween(html.style).to({opacity: 0}, 1000).easing(TWEEN.Easing.Quartic.In).onComplete(function () {
      html.style.display = 'none'
    })
    dis_.start()
    let year = document.getElementById('year')
    let block = loadmodel.tween(year.style).to({opacity: 1}, 1000).start().onStart(function () {
      year.style.display = 'block'
    })
    block.start()
    // let s1 = loadmodel.models.getObjectByName('s1')
    // let s2 = loadmodel.models.getObjectByName('s2')
    // let s3 = loadmodel.scene.getObjectByName('s3')
    // let s4 = loadmodel.scene.getObjectByName('s4')
    // let s5 = loadmodel.scene.getObjectByName('s5')
    // let s6 = loadmodel.scene.getObjectByName('s6')
    // loadmodel.scene.remove(s3)
    // loadmodel.scene.remove(s4)
    // loadmodel.scene.remove(s5)
    // loadmodel.scene.remove(s6)
    // loadmodel.scene.add(s1)
    // loadmodel.scene.add(s2)
      // console.log(loadmodel)
    let textures = this.getTexturesFromAtlasFile('static/models/lastsky', 'jpg')
    let materials = []
    for (var i = 0; i < 6; i++) {
      materials.push(new THREE.MeshBasicMaterial({map: textures[i]}))
    }
    let s1pano = loadmodel.scene.getObjectByName('s1_pano')
    s1pano.material = materials
    // 更新摄像机
    let splineCamera = loadmodel.scene.getObjectByName('s1_camera')
    // splineCamera.up.set(0, -1, 0)
    let tube = loadmodel.scene.getObjectByName('s1_tube')
    let tubeGeometry = tube.geometry
    let _lookat = loadmodel.scene.getObjectByName('s2_destination')
    let __lookat = loadmodel.scene.getObjectByName('s1_lookat')
    let center1 = new THREE.Vector3(__lookat.position.x, __lookat.position.y, __lookat.position.z)
    let center2 = new THREE.Vector3(_lookat.position.x, _lookat.position.y, _lookat.position.z)
    //
    let go1 = loadmodel.tween(tani).to({t: 0.786}, 5000).onComplete(function () {
      tani.t = 0.510
      go2.start()
    })
    let go2 = loadmodel.tween(tani).to({t: 0.211}, 5000).easing(TWEEN.Easing.Quartic.Out).onStart(function () {
      //loadmodel.scene.remove(s2)
    })
    go1.start()
      // console.log(tani.t)
    var bottomText = document.getElementById('bottom_text')
    var lastBox = document.getElementById('last_box')
    var bottomBox = document.getElementById('bottom_box')
    var lastTitle = document.getElementById('last_title')

    var logo = document.getElementById('logo')
    // console.log(tani.t)
    var textStart = loadmodel.tween(bottomText.style).to({opacity: 1}, 800).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      bottomText.style.display = 'block'
    })
    var bottomstart = loadmodel.tween(bottomBox.style).to({opacity: 1}, 800).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      bottomBox.style.display = 'block'
    }).onComplete(function () {
      textStart.start()
    })
    var titlestart = loadmodel.tween(lastTitle.style).to({opacity: 1}, 800).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      lastTitle.style.display = 'block'
    }).onComplete(function () {
      bottomstart.start()
    })
    var blo = loadmodel.tween(lastBox.style).to({opacity: 1}, 800).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      lastBox.style.display = 'block'
    })
    blo.start()

    var logostart = loadmodel.tween(logo.style).to({opacity: 1}, 800).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      logo.style.display = 'block'
    }).onComplete(function () {
      titlestart.start()
    })
    const foot1 = loadmodel.scene.getObjectByName('s1_turntable_1')
    const foot2 = loadmodel.scene.getObjectByName('s1_turntable_2')
    const foot3 = loadmodel.scene.getObjectByName('s1_turntable_3')
    const foot4 = loadmodel.scene.getObjectByName('s1_turntable_4')
    foot1.rotation.z = 1 * Math.PI
    foot2.rotation.z = 1 * Math.PI
    foot3.rotation.z = 1 * Math.PI
    foot4.rotation.z = 1 * Math.PI
    foot1.visible = true
    foot2.visible = true
    foot3.visible = true
    foot4.visible = true
    var rot1 = new TWEEN.Tween(foot1.rotation).to({x: -2 * Math.PI}, 3000)
    var rot2 = new TWEEN.Tween(foot2.rotation).to({x: -2 * Math.PI}, 3000)
    var rot3 = new TWEEN.Tween(foot3.rotation).to({x: -2 * Math.PI}, 3000)
    var rot4 = new TWEEN.Tween(foot4.rotation).to({x: -2 * Math.PI}, 3000)
    rot1.start().repeat(Infinity)
    rot2.start().repeat(Infinity)
    rot3.start().repeat(Infinity)
    rot4.start().repeat(Infinity)
    //
    logostart.delay(6000).start()
    loadmodel.camera = splineCamera
    loadmodel.sceneupdate = function () {
      let year = document.getElementById('year')
      if (tani.t < 0.5) {
        loadmodel.tween(year.style).to({opacity: 0}, 1000).start().onComplete(function () {
          year.style.display = 'none'
        })
      }
      if (tani.t < 0.211) {
        loadmodel.sceneupdate = function () {}
      }
      if (tani.t < 0.510) {
        let pano1 = loadmodel.scene.getObjectByName('s1_pano')
        pano1.position.copy(loadmodel.camera.position)
      }
      // 光
      let lensFlare = loadmodel.scene.getObjectByName('lens')
      if (tani.t > 0.47 && tani.t < 0.511) {
        let size = (((tani.t - 0.47) / 0.041) * 9300) + 700
        lensFlare.lensFlares[0].size = size
      } else {
        lensFlare.lensFlares[0].size = 700
      }
      // 光
      // console.log(loadmodel)
      let lensFlare2 = loadmodel.scene.getObjectByName('lens2')
      if (lensFlare2) {
        if (tani.t >= 0.786 && tani.t < 1) {
          let size = (((tani.t - 0.786) / 0.214) * 3000) + 700
          lensFlare2.lensFlares[0].size = size
        } else {
          lensFlare2.lensFlares[0].size = 700
        }
      }
      if (tani.t < 0.97 && tani.t >= 0) {
        let pos = tubeGeometry.parameters.path.getPointAt(tani.t)
        this.camera.position.copy(pos)
        if (tani.t <= 0.31) {
          splineCamera.position.set(pos.x, pos.y + 310 - tani.t * 1000, pos.z)
        } else {
          splineCamera.position.set(pos.x, pos.y, pos.z)
        }
        if (tani.t > 0.520) {
          splineCamera.lookAt(center2)
          let index = Math.floor((tani.t - 0.786) * 1000 / 5.7)
          year.innerHTML = 2018 - index
        } else {
          splineCamera.lookAt(center1)
        }
      } else {

        // loadmodel.stats = 's1_1'
        // scollFun.disable()
      }
    }
    var leftbtn = document.getElementById('left_btn')
    var rightbtn = document.getElementById('right_btn')
    leftbtn.addEventListener('click', function () {
      // alert(5)
      window.location.href = 'https://cdn.midoci.com/kuaiShou/index.html'
        return false
    })
    rightbtn.addEventListener('click', function () {
      // alert('自己分享')
      document.getElementById('sharepage').style.display = 'block'
    })
      document.getElementById('sharepage').onclick = function () {
          document.getElementById('sharepage').style.display = 'none'
      }
  }
  getTexturesFromAtlasFile (atlasImgUrl, type) {
    var textures = []
    var url = []
    url[0] = atlasImgUrl + 1 + '.' + type
    url[1] = atlasImgUrl + 3 + '.' + type
    url[2] = atlasImgUrl + 4 + '.' + type
    url[3] = atlasImgUrl + 5 + '.' + type
    url[4] = atlasImgUrl + 0 + '.' + type
    url[5] = atlasImgUrl + 2 + '.' + type
    let that = this
    for (var i = 0; i < 6; i++) {
      textures[i] = new THREE.Texture()
      textures[i] = that.getSigleTexture(textures[i], url[i])
    }
    return textures
  }
  getSigleTexture (Texture, image) {
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      canvas.height = tileWidth
      canvas.width = tileWidth
      context.drawImage(imageObj, 0, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
      Texture.image = canvas
      Texture.needsUpdate = true
    }
    imageObj.src = image
    return Texture
  }
}
export default Scene7



// WEBPACK FOOTER //
// ./src/js/views/Scene7.js